import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import classNames from "classnames";
import Icons from "../../icons";
import "./searchBox.scss";

const debounceTime = 2000;
let timeoutCall = null;
const SearchBox = (
  {
    autoid,
    options,
    getOptionCallBack,
    getCallBackDeviceSearch,
    isSearchDeviceActive = false,
    defaultVal = "",
    callFrom = ""
  },
  ref
) => {
  const [searchText, setSearchText] = useState(defaultVal);
  const [showDropDown, setShowDropDown] = useState(false);
  const [isSearchEnable, setIsSearchEnable] = useState(false);
  useImperativeHandle(ref, () => ({
    getIsSearchEnable: () => isSearchEnable,
    getSearchText: () => searchText,
  }));

  const debounceCallBack = (callBackFunc) => {
    if (timeoutCall !== null) {
      clearTimeout(timeoutCall);
    }
    timeoutCall = setTimeout(() => {
      callBackFunc();
    }, debounceTime);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (!searchText?.trim()?.length && callFrom === "dashboard") {
        setSearchText("");
      }
      setIsSearchEnable(false);
      setShowDropDown(false);
      debounceCallBack(() => {
        isSearchDeviceActive ? getOptionCallBack(false) : getOptionCallBack();
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSearchEnable(false);
        setShowDropDown(false);
        setSearchText(sessionStorage.getItem("searchKey") || "");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOnChange = (e) => {
    setSearchText(e.target.value);
    setIsSearchEnable(e.target.value.length > 0);

    if (!isSearchDeviceActive) {
      debounceCallBack(() => {
        getOptionCallBack();
      });
    }
    setShowDropDown(true);
  };

  useEffect(() => {
    if (isSearchDeviceActive) {
      getCallBackDeviceSearch();
    }
  }, [isSearchDeviceActive, searchText]);

  const handleOptionSelect = (item) => {
    setSearchText(item);
    setShowDropDown(false);
    setIsSearchEnable(false);
    setTimeout(() => {
      isSearchDeviceActive ? getOptionCallBack(false) : getOptionCallBack();
    }, 1000);
  };
  const handleClearBtn = () => {
    setSearchText("");
    setIsSearchEnable(false);
    setShowDropDown(false);
    debounceCallBack(() => {
      isSearchDeviceActive ? getOptionCallBack(false) : getOptionCallBack();
    });
  };

  const dropdownRef = useRef(null);

  const [dashBoardPlaceholder, setDashBoardPlaceholder] = useState("Search...");

  useEffect(() => {
    isSearchDeviceActive && setDashBoardPlaceholder("Search devices");
  }, [isSearchDeviceActive]);

  return (
    <div
      className={classNames("searchInputWrapper", {
        active: searchText.length > 0 && showDropDown,
        dashboardSearchInputActive: isSearchDeviceActive,
      })}
      ref={dropdownRef}
    >
      <input
        type="text"
        placeholder={dashBoardPlaceholder}
        name={autoid}
        id={autoid}
        onKeyDown={handleKeyDown}
        onChange={handleOnChange}
        value={searchText}
      />
      {searchText.length > 0 ? (
        <button
          type="button"
          id={`${autoid}_clear_btn`}
          onClick={handleClearBtn}
        >
          {isSearchDeviceActive ? (
            <>{Icons.closeCircleIcon}</>
          ) : (
            <>{Icons.closeIcon}</>
          )}
        </button>
      ) : (
        <button type="button" id={`${autoid}_search_btn`} className="searchBtn">
          {Icons.searchIcon}
        </button>
      )}
      {searchText.length > 0 && showDropDown && (
        <ul
          className={
            isSearchDeviceActive
              ? "searchDropDown dashboardActive"
              : "searchDropDown"
          }
        >
          {options.length > 0 ? (
            options.map((item, index) => (
              <li
                className={`${
                  isSearchDeviceActive ? "dashboardSearchActive" : ""
                } list-${index + 1}`}
                onClick={() => handleOptionSelect(item)}
                key={`${autoid}_option_${index + 1}`}
              >
                {Icons.routerIcon}
                <span>{item}</span>
              </li>
            ))
          ) : (
            <li>No Search Found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default forwardRef(SearchBox);
